import React from 'react';
import Dashboard from '../pages/Dashboard';
import Customer from '../pages/Customer';
import Vehicle from '../pages/Vehicle';
import As from '../pages/As';
import Recall from '../pages/Recall';
import Part from '../pages/Part';
// 🚀 [신규 추가] 새롭게 연결할 데이터 분석 컴포넌트를 상단에 안전하게 로드합니다.
import Analysis from '../pages/Analysis';
// 사용자님의 실제 파일명인 SystemConfig로 정확히 불러옵니다.
import SystemConfig from '../pages/SystemConfig'; 
import { MENUS } from '../config/menuConfig';

const PageRouter = ({ currentPath, user, onMenuClick }) => {
  // 1. 현재 경로가 메뉴 목록에 있는지 확인
  const currentMenu = MENUS.find(m => m.id === currentPath);
  
  // 2. 권한 방어 코드 (메뉴에 없으면 통과, 있으면 권한 체크)
  const isAllowed = currentMenu ? currentMenu.roles.includes(user.role) : true;

  if (!isAllowed) {
    return <div style={{padding:'50px', fontSize:'20px'}}>🚫 권한이 없습니다.</div>;
  }

  // 3. 🚀 [수정 포인트] menuConfig.js의 id와 정확히 일치시킵니다.
  switch (currentPath) {
    case 'dashboard':
      return <Dashboard user={user} onMenuClick={onMenuClick} />;
    case 'customer':
      return <Customer />;
    case 'vehicle':
      return <Vehicle />;
    case 'as':
      return <As />;
    case 'recall':
      return <Recall />;
    case 'part':
      return <Part user={user} />;
    // 🚀 [신규 추가] 'analysis' 메뉴를 누르면 데이터 분석 화면 컴포넌트를 열어줍니다.
    case 'analysis':
      return <Analysis user={user} />;
    // 🚀 'settings'에서 'system'으로 변경했습니다.
    case 'system': 
      return <SystemConfig />;
    default:
      return <Dashboard user={user} onMenuClick={onMenuClick} />;
  }
};

export default PageRouter;